import assetsConfig from "../../assetsConfig";

const replaceSingleEntry = (str?: string): string => {
	const configStr = `Single ${assetsConfig.labels.entry.singular}`;
	const replacedStr = str
		? str.replaceAll("Single Entry", configStr)
		: configStr;

	return replacedStr;
};

export default replaceSingleEntry;
